export enum ColorPickerDisplayType {
  HEX = "Hex",
  RGB = "Rgb"
}
